module.exports = __webpack_public_path__ + "static/media/vehicleListIcon.29a709af.svg";